import type { ResizeEdge } from "./useBlockResize";

interface ResizeHandlesProps {
  handleProps: (edge: ResizeEdge) => React.HTMLAttributes<HTMLDivElement>;
  showStart?: boolean;
  showEnd?: boolean;
}

/**
 * Top/bottom edge handles for block resize. The interactive area is a
 * finger-friendly 64×16px strip centered on the edge, stacked above the
 * hover-action cluster where the two meet on narrow blocks; `touch-action:
 * none` lets pointermove drive the gesture on touch instead of scrolling.
 */
export function ResizeHandles({
  handleProps,
  showStart = true,
  showEnd = true,
}: ResizeHandlesProps) {
  return (
    <>
      {showStart && (
        <div
          {...handleProps("start")}
          onClick={(event) => event.stopPropagation()}
          className="absolute -top-2 left-1/2 z-20 flex h-4 w-16 -translate-x-1/2 touch-none cursor-ns-resize items-center justify-center"
          role="separator"
          aria-label="Adjust start time"
          data-calendar-transient-control
        >
          <span className="h-1.5 w-9 rounded-full bg-info ring-2 ring-surface" />
        </div>
      )}
      {showEnd && (
        <div
          {...handleProps("end")}
          onClick={(event) => event.stopPropagation()}
          className="absolute -bottom-2 left-1/2 z-20 flex h-4 w-16 -translate-x-1/2 touch-none cursor-ns-resize items-center justify-center"
          role="separator"
          aria-label="Adjust end time"
          data-calendar-transient-control
        >
          <span className="h-1.5 w-9 rounded-full bg-info ring-2 ring-surface" />
        </div>
      )}
    </>
  );
}
